// extracted by mini-css-extract-plugin
module.exports = {"mopedContent":"priser-module--mopedContent--3oHte"};